import { lazyLoad } from 'utils/loadable';

export const DocumentTabLoadable = lazyLoad(
  () => import('./DocumentsTab'),
  module => module.DocumentsTab,
);
